import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Star, Loader2, CheckCircle, Clock, TrendingUp, ShoppingCart, ExternalLink } from 'lucide-react';
import Layout from '../../components/Layout';
import api from '../../utils/api';

export default function DestaqueCandidato() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const statusRetorno = params.get('status');
  const paymentId = params.get('payment_id') || params.get('collection_id');

  const [status, setStatus]         = useState(null);
  const [loading, setLoading]       = useState(true);
  const [comprando, setComprando]   = useState(false);
  const [confirmando, setConfirmando] = useState(false);

  const carregar = useCallback(() => {
    setLoading(true);
    api.get('/candidatos/destaque/status').then(r => setStatus(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);
  useEffect(() => { carregar(); }, [carregar]);

  useEffect(() => {
    if (statusRetorno === 'approved' && paymentId) {
      setConfirmando(true);
      api.get(`/candidatos/destaque/mp/status/${paymentId}`)
        .then(r => { if (r.data.paid) toast.success('Destaque ativado por 30 dias!'); })
        .catch(() => {})
        .finally(() => { setConfirmando(false); carregar(); navigate('/candidato/destaque', { replace: true }); });
    } else if (statusRetorno === 'rejected') {
      toast.error('Pagamento nao concluido.');
    }
  // eslint-disable-next-line
  }, []);

  const comprar = async () => {
    setComprando(true);
    try {
      const { data } = await api.post('/candidatos/destaque/mp');
      const url = data.sandbox ? data.sandbox_init_point : data.init_point;
      if (url) window.location.href = url;
      else toast.error('Nao foi possivel obter o link de pagamento.');
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao iniciar pagamento.');
    }
    setComprando(false);
  };

  const ativo = status?.ativo;

  return (
    <Layout title="Destaque do Perfil" subtitle="Apareca em primeiro nas vagas compativeis">
      <div className="max-w-lg space-y-5">
        {confirmando && (
          <div className="card p-4 flex items-center gap-2 text-sm text-gray-600"><Loader2 className="animate-spin" size={16}/> Confirmando seu pagamento...</div>
        )}

        {loading ? (
          <div className="card p-10 text-center text-gray-400"><Loader2 className="animate-spin mx-auto"/></div>
        ) : ativo ? (
          <div className="card p-6 text-center">
            <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
              <Star size={32} className="text-amber-500" fill="#f59e0b"/>
            </div>
            <h2 className="font-sora font-black text-acre-dark text-xl mb-1">Seu perfil esta em destaque!</h2>
            <p className="text-gray-500 text-sm mb-3">Voce aparece em primeiro nas vagas com 70%+ de compatibilidade.</p>
            <p className="inline-flex items-center gap-1.5 text-sm font-bold text-amber-600 bg-amber-50 px-3 py-1.5 rounded-full">
              <Clock size={14}/> Expira em {status.dias_restantes} dia(s)
            </p>
          </div>
        ) : (
          <div className="card p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-xl bg-amber-100 flex items-center justify-center"><Star size={24} className="text-amber-500"/></div>
              <div>
                <p className="font-sora font-bold text-acre-dark">Destaque do Curriculo</p>
                <p className="text-xs text-gray-400">Apareca em primeiro lugar nas vagas</p>
              </div>
              <p className="ml-auto font-sora font-black text-2xl text-acre-dark">R$ 9,80</p>
            </div>
            <ul className="space-y-2 mb-5 text-sm text-gray-600">
              {['Seu perfil aparece em 1o nas vagas com 70%+ de match','Mais visibilidade para as empresas','Vale por 30 dias'].map((t,i)=>(
                <li key={i} className="flex items-center gap-2"><CheckCircle size={15} className="text-acre-green flex-shrink-0"/>{t}</li>
              ))}
            </ul>
            <div className="flex items-center gap-2 bg-blue-50 border border-blue-100 rounded-xl p-3 mb-5">
              <TrendingUp size={16} className="text-blue-500 flex-shrink-0"/>
              <p className="text-xs text-blue-700">O destaque so aparece nas vagas em que voce tem <strong>pelo menos 70% de compatibilidade</strong>.</p>
            </div>
            <button onClick={comprar} disabled={comprando}
              className="w-full py-4 bg-[#009EE3] hover:bg-[#007ab5] text-white font-sora font-black rounded-xl flex items-center justify-center gap-3 disabled:opacity-60 transition-colors">
              {comprando ? <><Loader2 size={18} className="animate-spin"/> Redirecionando...</> : <><ShoppingCart size={18}/> Destacar meu perfil <ExternalLink size={14}/></>}
            </button>
            <p className="text-xs text-gray-400 text-center mt-3">Pagamento seguro - PIX ou cartão</p>
          </div>
        )}
      </div>
    </Layout>
  );
}
